export default __webpack_public_path__ + "static/media/06.57b3d5bd.png";